import { render, staticRenderFns } from "./FormPulsa.vue?vue&type=template&id=abff811a"
import script from "./FormPulsa.vue?vue&type=script&lang=js"
export * from "./FormPulsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports